import React, { Component } from 'react'

export default class NotFound extends Component {
    render() {
        return (
            <>
                <div className="p-5 mb-4 bg-light rounded-3">
                    <div className="container-fluid py-5">
                        <h1 className="display-5 fw-bold">Something went wrong :(</h1>
                        <p className="col-md-8 fs-4">
                            The page you're looking for doesn't seem to exist.
                        </p>
                    </div>
                </div>
            </>
        )
    }
}
